import React from 'react';
import ReactDOM from 'react-dom';
// import './Scss/index.scss';
import 'semantic-ui-css/semantic.css';
import 'react-table/react-table.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import "react-toastify/dist/ReactToastify.css";

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById('root')
);
